<template lang="pug">
  footer#app-footer
    nav
      ul
        li
          | Criado por&nbsp;
          a(href="https://github.com/rafasoares" target="_blank") Rafael Soares
        li &bull;
        li
          a(href="https://feedback.toma.ae" target="_blank") Sugestões?
        li &bull;
        li
          router-link(to="/about") Sobre
        li &bull;
        li
          router-link(to="/privacy") Privacidade
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style lang="stylus" scoped>
  @import "~nib/index"
  @import "~jeet/jeet"

  $jeet['max-width'] = 768px


  #app-footer
    fixed bottom left right
    font-size .8rem
    background-color white

    nav
      center($pad: 3%)

      ul
        padding 1rem 0 0
        border-top 1px solid lightgrey
        display flex
        justify-content space-evenly
        li
          list-style none
</style>



// WEBPACK FOOTER //
// src/components/AppFooter.vue